import templateUrl from './shiftTemplatesComponent.html';

const EDUCATION_PLACEMENT_STEP = 'shiftTemplatePlacementEducationStep';
const EDUCATION_PLACEMENT_STEP_1 = `${EDUCATION_PLACEMENT_STEP}1`;
const EDUCATION_PLACEMENT_STEP_2 = `${EDUCATION_PLACEMENT_STEP}2`;
const EDUCATION_PLACEMENT_STEP_3 = `${EDUCATION_PLACEMENT_STEP}3`;
const EDUCATION_IGNORE_HIDE = 'Shift templates education ignore hide';

class ShiftTemplatesCtrl {
  constructor(
    Authentication,
    ConfirmService,
    EventCollection,
    Education,
    KeyboardService,
    PersonaCollection,
    ShiftUtils,
    Utils,
    orderByFilter,
    $scope,
    $timeout,
    $uibModal
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      ConfirmService,
      EventCollection,
      Education,
      KeyboardService,
      PersonaCollection,
      ShiftUtils,
      Utils,
      orderByFilter,
      $scope,
      $timeout,
      $uibModal,
    });
  }

  $onInit() {
    this.templates = [];

    this.$scope.$watch('ctrl.open', async () => {
      if (this.open) {
        await this.loadTemplates();
        this._maybeShowEducationStep1();
      }
    });

    this.$scope.$on('socket:shift:templates:sync', () => {
      if (this.open) {
        this.loadTemplates();
      }
    });

    this._prepareEducation();

    this._unregisterKey = this.KeyboardService.on(this.KeyboardService.KEYS.ESC, () =>
      this.escapePlacementMode()
    );
  }

  $onDestroy() {
    this._unregisterKey();
  }

  $onChanges({ filter }) {
    if (filter && !filter.isFirstChange() && this.open) {
      this.loadTemplates();
    }
  }

  close() {
    this.open = false;
    this._resetTemplatePlacementEducation();
  }

  async loadTemplates() {
    this.templatesLoading = true;
    this.templates = await this.ShiftUtils.getFilteredShiftTemplates(this.filter);

    this.$scope.$evalAsync(() => {
      this.templatesLoading = false;
    });
  }

  async createShiftTemplate() {
    const newTemplate = await this.ShiftUtils.openShiftTemplateModal();

    if (newTemplate && !this.templatesLoading) {
      this.loadTemplates();
    }
  }

  async editTemplate(template) {
    const updatedTemplate = await this.ShiftUtils.openShiftTemplateModal(template);

    if (updatedTemplate && !this.templatesLoading) {
      this.loadTemplates();
    }
  }

  async deleteTemplate(template) {
    await this.ConfirmService.ask(`Do you want to remove "${template.name}" shift template?`);
    await this.EventCollection.deleteShiftTemplate(template.id);
    this.loadTemplates();
  }

  togglePlacementMode(template) {
    this._resetTemplatePlacementEducation();

    if (this.templatePlacementModeShift === template) {
      this.templatePlacementModeShift = null;
    } else {
      this.templatePlacementModeShift = template;
      this._maybeShowEducationStep2();
    }
  }

  escapePlacementMode() {
    this.templatePlacementModeShift = null;
    this.Education.hide();
  }

  _maybeShowEducationStep1() {
    if (
      this.templates?.length &&
      !this.Authentication.user.settings.clientFlags[`${EDUCATION_PLACEMENT_STEP_1}Shown`]
    ) {
      this._showPlacementEducationStep1(this.orderByFilter(this.templates, 'name')[0]);
    }
  }

  _maybeShowEducationStep2() {
    if (!this.Authentication.user.settings.clientFlags[`${EDUCATION_PLACEMENT_STEP_2}Shown`]) {
      this._showPlacementEducationStep2();
    }
  }

  _maybeShowEducationStep3() {
    if (!this.Authentication.user.settings.clientFlags[`${EDUCATION_PLACEMENT_STEP_3}Shown`]) {
      this._showPlacementEducationStep3();
    }
  }

  _prepareEducation() {
    this.$scope.$on('education:hide', (e, { config, reason }) => {
      if (reason === EDUCATION_IGNORE_HIDE || !config.name.startsWith(EDUCATION_PLACEMENT_STEP)) {
        return;
      }

      delete this[`${config.name}Data`];
      this.Authentication.saveClientFlags({
        [`${config.name}Shown`]: true,
      });

      if (config.name === EDUCATION_PLACEMENT_STEP_2) {
        this.$timeout(() => this._maybeShowEducationStep3());
      }
    });
  }

  _resetTemplatePlacementEducation() {
    this.Education.hide();
  }

  _showPlacementEducationStep1(template) {
    this.shiftTemplatePlacementEducationStep1Data = template;
    this.Education.show({
      content: `
        <div>
          We've made applying templates much faster! ⚡
        </div>
        <br>
        <div>
          Click
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.65">
            <rect x="1" y="5" width="10" height="10" rx="1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5 4.33333V2C5 1.44771 5.44772 1 6 1H14C14.5523 1 15 1.44772 15 2V10C15 10.5523 14.5523 11 14 11H11.6667" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            </svg>
          to copy a template.
        </div>
        <div style="position: absolute; bottom: 30px; font-size: 85%;">
          Step <strong>1</strong> <i>of</i> <strong>3</strong>
        </div>
      `,
      name: EDUCATION_PLACEMENT_STEP_1,
      selector: `#education-template-placement-${template.id}`,
      chevron: 'top-right',
    });
  }

  _showPlacementEducationStep2() {
    this.Education.show({
      content: `
        <div>
          Apply it as many times as needed by clicking on your schedule.
        </div>
        <div style="position: absolute; bottom: 30px; font-size: 85%;">
          Step <strong>2</strong> <i>of</i>&nbsp;<strong>3</strong>
        </div>
      `,
      name: EDUCATION_PLACEMENT_STEP_2,
      selector: '#shift-calendar-day',
      chevron: 'left-top',
      offset: { x: -12, y: 5 },
    });
  }

  _showPlacementEducationStep3() {
    this.shiftTemplatePlacementEducationStep3Data = true;

    this.Education.show({
      content: `
        <div>
          To stop applying a template, press ESC or click the
            <svg style="position: relative; top: 3px; margin-left: 2px;" width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 1L1 8L7 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          to open the templates side bar.
        </div>
        <div style="position: absolute; bottom: 30px; font-size: 85%;">
          Step <strong>3</strong> <i>of</i> <strong>3</strong>
        </div>
      `,
      name: EDUCATION_PLACEMENT_STEP_3,
      selector: '#placement-mode-back',
      chevron: 'top-right',
      offset: { y: -10 },
    });
  }
}

export default {
  templateUrl,
  controller: ShiftTemplatesCtrl,
  controllerAs: 'ctrl',
  bindings: {
    open: '=',
    filter: '<',
    templatePlacementModeShift: '=',
  },
};
